import * as React from 'react'

import { Box, Tag, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import type Leave from 'modules/shift_management/store/internal/models/Leave'

interface Props {
  date: moment.Moment
  leave: Leave
}

const LeaveItem = ({ date, leave }: Props) => {
  const employee = leave.employeeModel
  const [{ shiftsConflicts }] = useSchedule()

  if (!employee) return null

  const hasConflict = shiftsConflicts.hasConflictWithLeave(date, leave)

  const user = employeeUser(employee)

  return (
    <Box key={leave.id} gap="s12" flexDirection="column" alignItems="flexStart">
      <Box flexDirection="row" alignItems="center" gap="s12">
        <UserAvatar size="s24" user={user} />
        <Text.Normal>{user.fullName()}</Text.Normal>
      </Box>
      {hasConflict && (
        <Tag type="radical">{i18n.t('shift_management.sidepanel.shift_conflict')}</Tag>
      )}
    </Box>
  )
}

export default observer(LeaveItem)
